import type { exportacao as pt } from '../pt-BR/exportacao';
import type { Traducao } from '../Traducao';

export const exportacao = {
  explicacao:
    'The file lists who wants to receive the gift in Brazil, with size and delivery address, the total per size, and on another sheet who receives the pouch abroad. Excluded participants are not included.',
  usoInterno: 'Include the "Uso interno" sheet with the employee ID',
  usoInternoHint: 'Do not send this sheet to the supplier.',
  baixar: 'Download',
  baixado: 'File generated.',
  participantes: { botao: 'Export participants' },
} as const satisfies Traducao<typeof pt>;
